/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const normalizeObject = (fields) => {
  for (const prop of Object.getOwnPropertyNames(fields)) {
    if (!fields[prop]) {
      delete fields[prop];
    }
  }
  return fields;
};

export const normalizeAndRemoveFields = (item, fieldsToDelete) => {
  for (const prop of Object.getOwnPropertyNames(item)) {
    if (
      (!['boolean', 'number'].includes(typeof item[prop]) && !item[prop]) ||
      fieldsToDelete.includes(prop)
    ) {
      delete item[prop];
    }
  }
  return item;
};
